import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import './analytics';

import './styles/appstyles.scss';


ReactDOM.render(
        <App />,
    document.getElementById("root")
);